import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import article from "./modules/article";
import drag from "./modules/drag";
import cacheView from "./modules/cacheView";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    isPc: false,
    isMobile: false,
    htmlFontSize: undefined,
    parentModel: {},
  },
  getters: {
    htmlFontSize: (state) => state?.htmlFontSize,
    isPc: (state) => state?.isPc,
    isMobile: (state) => state?.isMobile,
    userInfo: (state) => state?.user?.userInfo,
    parentModel: (state) => state?.parentModel,
    //
    articleCategory: (state) => state?.article?.articleCategory || [],
    articleType: (state) => state?.article?.articleType || [],
    articleTypeObj: (state) => state?.article?.articleTypeObj || {},
    cacheViewArr: (state) => state?.cacheView?.cacheViewArr || [],
  },
  mutations: {
    SET_IS_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    },
    SET_IS_PC(state, isPc) {
      state.isPc = isPc;
    },
    SET_HTML_FONT_SIZE(state, htmlFontSize) {
      state.htmlFontSize = htmlFontSize;
    },
    SET_PARENT_MODEL: (state, parentModel) => {
      state.parentModel = parentModel;
    },
  },
  actions: {
    setParentModel({ commit }, parentModel) {
      commit("SET_PARENT_MODEL", parentModel);
    },
  },
  // actions: {},
  modules: { user, article, drag, cacheView },
});

export function setStore(parentStore) {
  store = parentStore;
}

export function getStore() {
  return store;
}

export default store;
